// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2eXok","additionalInfo":"AgreementModal_additionalInfo__1PHSe"};